import { useEffect } from "react";

/** Remove all existing tags by selector (avoid duplicates) */
function removeAll(selector) {
  document.querySelectorAll(selector).forEach((el) => el.remove());
}
export default function SeoMeta({ seopages }) {

  useEffect(() => {
    if (!seopages) return;

    document.title = seopages.title || "Rankridge International School";

    removeAll('meta[name="description"]');
    removeAll('meta[name="keywords"]');
    removeAll('meta[property^="og:"]');
    removeAll('meta[name^="twitter:"]');

// helper for canonical link
    const setCanonical = (url) => {
      if (!url) return;
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
    };

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", seopages.description);
    setMeta("keywords", seopages.keywords);
    setMeta("og:title", seopages.title, "property");
    setMeta("og:description", seopages.og_description || seopages.description, "property");
    setMeta("og:image", seopages.og_image, "property");
    setMeta("og:url", seopages.canonical_path, "property");

      setCanonical(seopages.canonical_path);
  }, [seopages]);

  return null; // nothing to render, only head update
}
// import Head from "next/head";

// export default function CoursePage({ course }) {
//   return (
//     <>
//       <Head>
//         <title>{course.title} | My Academy</title>
//         <meta name="description" content={course.description} />
//         <meta property="og:title" content={course.title} />
//         <meta property="og:description" content={course.description} />
//         <meta property="og:image" content={course.image} />
//       </Head>
//       <h1>{course.title}</h1>
//     </>
//   );
// }


// import React from "react";
// import { Helmet } from "react-helmet-async";


// function toAbsolute(url) {
//   if (!url) return "";
//   try {
//     return url.startsWith("http")
//       ? url
//       : new URL(url, typeof window !== "undefined" ? window.location.origin : "https://rankridge.example.com").href;
//   } catch {
//     return url;
//   }
// }

// export default function SeoMeta({ seopages = {} }) {
//   const {
//     title,
//     description,
//     keywords,
//     canonical_path,
//     og_title,
//     og_description,
//     og_image,
//     robots = "index,follow",
//     locale = "en_IN",
//     site_name = "Rankridge International School",
//     twitter_card = "summary_large_image",
//     jsonld,
//   } = seopages;

//   const canonical = toAbsolute(canonical_path);
//   const finalTitle = title || "Rankridge International School";
//   const finalOgTitle = og_title || finalTitle;
//   const finalOgDesc = og_description || description || "";
//   const finalOgUrl = canonical || (typeof window !== "undefined" ? window.location.href : "");

//   return (
//     <>
//       <Helmet>
//         {/* Primary */}
//         <title>{finalTitle}</title>
//         {description && <meta name="description" content={description} />}
//         {keywords && <meta name="keywords" content={keywords} />}
//         <meta name="robots" content={robots} />
//         {canonical && <link rel="canonical" href={canonical} />}

//         {/* Open Graph */}
//         <meta property="og:type" content="website" />
//         <meta property="og:title" content={finalOgTitle} />
//         {finalOgDesc && <meta property="og:description" content={finalOgDesc} />}
//         {finalOgUrl && <meta property="og:url" content={finalOgUrl} />}
//         {og_image && <meta property="og:image" content={og_image} />}
//         <meta property="og:site_name" content={site_name} />
//         <meta property="og:locale" content={locale} />

//         {/* Twitter */}
//         <meta name="twitter:card" content={twitter_card} />
//         <meta name="twitter:title" content={finalOgTitle} />
//         {finalOgDesc && <meta name="twitter:description" content={finalOgDesc} />}
//         {og_image && <meta name="twitter:image" content={og_image} />}

//         {/* Helpful defaults */}
//         <meta name="viewport" content="width=device-width, initial-scale=1" />
//         {/* You can add <link rel="icon" ...> here if needed */}
//       </Helmet>

//       {/* Optional JSON-LD */}
//       {jsonld && (
//         <Helmet>
//           <script type="application/ld+json">
//             {JSON.stringify(jsonld)}
//           </script>
//         </Helmet>
//       )}
//     </>
//   );
// }

